<template>
    <button id="GUIDE" name="GUIDE" class="btn" data-vcode="GUIDE">
        <img class="soft-img" src="/images/icons/ic_grid_white_56.svg" alt="" role="img" aria-hidden="true" />
        <label> {{ $t('guideButton') }}</label>
    </button>
</template>
<script>
export default {};
</script>
